import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { selectClients } from '../../store/slices/clients.slice';
import { ClientDto } from '../../commonTypes/client.types';

export const useClients = () => useSelector<RootState, ClientDto[]>(selectClients);
